var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VContainer',{style:({
    padding: 0,
    height: !_vm.$auth.ready() ? '100vh' : '100%',
  }),attrs:{"fluid":""}},[(_vm.$auth.ready())?_c('router-view'):_c('VRow',{staticClass:"mt-4",style:({
      height: '100vh',
    }),attrs:{"row":"","fluid":"","justify-center":"","align-center":""}},[_c('VCol',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"}},[_c('VProgressCircular',{attrs:{"indeterminate":"","color":"#F5BA2B"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }